export const UI_TEXT_BY_LANG = {
    EN: {
        title: "WUI-Cast",
        helper: "Enter your address to see routes and hear your plan.",
        placeholder: "Enter address",
        nextSteps: "Next Steps",
        play: "Play",
        pause: "Pause",

        takeActionTitle: "Take Action Now",
        takeActionSubtitle: "Protect your family now",

        evacTimesTab: "Your Evacuation Times",

        disclaimerTitle: "Disclaimer",
        disclaimerBullets: [
        "WUI-Cast is for wildfire preparedness and education only.",
        "In an actual emergency, always follow official alerts, evacuation orders, road closures, and re-entry instructions.",
        "In California, evacuations are managed by authorized public safety agencies, including law enforcement, fire officials, emergency management, CHP, CAL FIRE, and local authorities.",
        "WUI-Go! simulations are planning estimates only and do not include real-time fire conditions, road closures, traffic control, or emergency field interventions.",
        "WUI-Go! and partners assume no responsibility for actions taken based on this information."
        ],
        replay: "Replay",
        loadingSteps: [
        "Fetching location……",
        "Loading routes……",
        "Loading podcast……"
        ],
        stepCard: {
            open: "Open",
            steps: "Steps",
            hide: "Hide",
            play: "Play",
            stop: "Stop",
            clickToSeek: "Click to seek",
        },
        share_button: "Share",
        guidedNextSteps: {
            timeCallout: "3 minutes now can save your life later",
            doItNow: "Do it now",
            skip: "Skip",
            back: "Back",
            showSteps: "Show steps",
            hideSteps: "Hide steps"
        },
        findPlan: "See Evacuation Guide",
        addressEntryFlow: {
            subtitle: "Get your evacuation audio guide",
            startAudioGuide: "Start audio guide",
            entryDisclaimerLines: [
                "Assumes multiple zones evacuate together and does not account for intervention by local authorities.",
                "Always follow official instructions from law enforcement, fire officials, and local emergency authorities. They manage evacuations"
            ],
            searchBarPlaceholder: "Enter address and press Enter",
            pickOnMapHint: "Click on the map to choose your address",
            searchingAddresses: "Searching addresses...",
            addressFoundPrefix: "Address found",
            useMyLocation: "Use my location",
            pickOnMap: "Pick on map",
            loadingReadyLabel: "GUIDE READY",
            loadingBuildingLabel: "BUILDING YOUR GUIDE",
            loadingReadyTitle: "All set.",
            loadingInProgressTitle: "This usually takes a few seconds...",
            autoplayReadyTitle: "Your evacuation guide is ready!",
            currentLocationLabel: "Current location",
            progressSteps: [
                "Finding your address",
                "Loading simulation data",
                "Preparing your guide",
                "Loading audio"
            ],
            errors: {
                mapPointInvalid: "We could not use that map point. Try another location.",
                locationAccessUnavailable: "Location access is not available on this device.",
                currentLocationFailed: "Could not use your current location. Please enter an address.",
                locationPermissionDenied: "Location permission denied. Please enter your address.",
                addressNotFound: "We could not find that address. Try selecting from the suggestions.",
                selectMapStartPoint: "Click on the map first to choose your starting point."
            }
        },
    },
    ES: {
        title: "WUI-Cast",
        helper: "Ingresa tu dirección para ver las rutas y escuchar tu plan.",
        placeholder: "Ingresa tu dirección",
        nextSteps: "Próximos pasos",
        play: "Reproducir",
        pause: "Pausar",

        takeActionTitle: "Actúa ahora",
        takeActionSubtitle: "Protege a tu familia ahora",

        evacTimesTab: "Tus tiempos de evacuación",

        disclaimerTitle: "Descargo de responsabilidad",
        disclaimerBullets: [
        "WUI-Cast es solo para preparación y educación sobre incendios forestales.",
        "En una emergencia real, sigue siempre las alertas oficiales, las órdenes de evacuación, los cierres de carreteras y las instrucciones de reingreso.",
        "En California, las evacuaciones son gestionadas por agencias autorizadas de seguridad pública, incluidas las fuerzas del orden, los bomberos, la gestión de emergencias, CHP, CAL FIRE y las autoridades locales.",
        "Las simulaciones de WUI-Go! son solo estimaciones de planificación y no incluyen condiciones reales del incendio, cierres de carreteras, control de tráfico ni intervenciones de emergencia en campo.",
        "WUI-Go! y sus socios no asumen responsabilidad por acciones tomadas con base en esta información."
        ],
        replay: "Repetir",
        loadingSteps: [
        "Buscando la ubicación……",
        "Cargando rutas……",
        "Cargando podcast……"
        ],
        stepCard: {
            open: "Abrir",
            steps: "Pasos",
            hide: "Ocultar",
            play: "Reproducir",
            stop: "Detener",
            clickToSeek: "Haz clic para avanzar",
        },
        share_button: "Compartir",
        guidedNextSteps: {
            timeCallout: "3 minutos ahora pueden salvarte la vida después",
            doItNow: "Hazlo ahora",
            skip: "Omitir",
            back: "Atrás",
            showSteps: "Mostrar pasos",
            hideSteps: "Ocultar pasos"
        },
        findPlan: "Buscar plan de evacuación",
        addressEntryFlow: {
            subtitle: "Obtén tu plan de evacuación en audio",
            startAudioGuide: "Iniciar guía de audio",
            entryDisclaimerLines: [
                "Asume que varias zonas evacúan juntas y no considera la intervención de las fuerzas del orden ni de agencias de emergencia.",
                "En una emergencia real, sigue siempre las instrucciones oficiales de las fuerzas del orden, los bomberos y las autoridades locales de emergencia."
            ],
            searchBarPlaceholder: "Ingresa una dirección y presiona Enter",
            pickOnMapHint: "Haz clic en el mapa para elegir tu dirección",
            searchingAddresses: "Buscando direcciones...",
            addressFoundPrefix: "Dirección encontrada",
            useMyLocation: "Usar mi ubicación",
            pickOnMap: "Elegir en el mapa",
            loadingReadyLabel: "GUÍA LISTA",
            loadingBuildingLabel: "CREANDO TU GUÍA",
            loadingReadyTitle: "Todo listo.",
            loadingInProgressTitle: "Esto suele tardar unos segundos...",
            autoplayReadyTitle: "¡Tu guía de evacuación está lista!",
            currentLocationLabel: "Ubicación actual",
            progressSteps: [
                "Buscando tu dirección",
                "Cargando datos de simulación",
                "Preparando tu guía",
                "Cargando audio"
            ],
            errors: {
                mapPointInvalid: "No pudimos usar ese punto del mapa. Prueba otra ubicación.",
                locationAccessUnavailable: "El acceso a la ubicación no está disponible en este dispositivo.",
                currentLocationFailed: "No se pudo usar tu ubicación actual. Ingresa una dirección.",
                locationPermissionDenied: "Permiso de ubicación denegado. Ingresa tu dirección.",
                addressNotFound: "No pudimos encontrar esa dirección. Intenta seleccionar una de las sugerencias.",
                selectMapStartPoint: "Primero haz clic en el mapa para elegir tu punto de inicio."
            }
        },
    },
    MN: {
        title: "WUI-Cast",
        helper: "輸入你的地址以查看路線並收聽你的計畫。",
        placeholder: "輸入地址",
        nextSteps: "下一步",
        play: "播放",
        pause: "暂停",

        takeActionTitle: "立即行动",
        takeActionSubtitle: "现在就保护你的家人",

        evacTimesTab: "你的撤离时间",

        disclaimerTitle: "免责声明",
        disclaimerBullets: [
        "WUI-Cast 仅用于野火防备和教育。",
        "在真实紧急情况下，请始终遵循官方警报、疏散命令、道路封闭以及返回指示。",
        "在加利福尼亚州，疏散由授权的公共安全机构管理，包括执法部门、消防官员、应急管理部门、CHP、CAL FIRE 和地方当局。",
        "WUI-Go! 模拟仅为规划估算，不包括实时火情、道路封闭、交通管制或应急现场干预。",
        "WUI-Go! 及其合作伙伴对基于本信息采取的行动不承担责任。"
        ],
        replay: "重播",
        loadingSteps: [
        "正在获取位置……",
        "正在加载路线……",
        "正在加载播客……"
        ],
        stepCard: {
            open: "打开",
            steps: "步骤",
            hide: "隐藏",
            play: "播放",
            stop: "停止",
            clickToSeek: "点击跳转",
        },
        share_button: "分享",
        guidedNextSteps: {
            timeCallout: "现在花 3 分钟，以后可能救你一命",
            doItNow: "现在就做",
            skip: "跳过",
            back: "返回",
            showSteps: "显示步骤",
            hideSteps: "隐藏步骤"
        },
        findPlan: "查找疏散计划",
        addressEntryFlow: {
            subtitle: "获取你的疏散音频计划",
            entryDisclaimerLines: [
                "假设多个区域同时疏散，且未考虑执法部门或应急机构的干预。",
                "在真实紧急情况下，请始终遵循执法部门、消防官员和当地应急部门的官方指示。"
            ],
            searchBarPlaceholder: "输入地址并按 Enter",
            pickOnMapHint: "在地图上点击以选择你的地址",
            searchingAddresses: "正在搜索地址...",
            addressFoundPrefix: "已找到地址",
            useMyLocation: "使用我的位置",
            pickOnMap: "在地图上选择",
            loadingReadyLabel: "指南已就绪",
            loadingBuildingLabel: "正在生成你的指南",
            loadingReadyTitle: "全部就绪。",
            loadingInProgressTitle: "这通常需要几秒钟...",
            autoplayReadyTitle: "你的疏散指南已准备就绪！",
            currentLocationLabel: "当前位置",
            progressSteps: [
                "正在查找你的地址",
                "正在加载模拟数据",
                "正在准备你的指南",
                "正在加载音频"
            ],
            errors: {
                mapPointInvalid: "无法使用该地图点，请尝试其他位置。",
                locationAccessUnavailable: "此设备无法访问位置信息。",
                currentLocationFailed: "无法使用你当前的位置，请输入地址。",
                locationPermissionDenied: "位置权限被拒绝，请输入你的地址。",
                addressNotFound: "找不到该地址，请从建议中选择。",
                selectMapStartPoint: "请先在地图上点击选择起点。"
            }
        },
    }
  };
  
// Small safe accessor with fallback
export function getUiText(lang = "EN") {
const code = String(lang || "EN").toUpperCase();
return UI_TEXT_BY_LANG[code] || UI_TEXT_BY_LANG.EN;
}
